import { useLocalSearchParams } from "expo-router";
import { useTranslation } from "react-i18next";
import { ActivityIndicator, View } from "react-native";

import { useParentStackTitle } from "@/components/navigation/useParentStackTitle";
import { LeaveDaysScreen } from "@/features/pickupRequest/LeaveDaysScreen";
import { useChildren } from "@/features/selectedChild";

export default function ChildLeaveDaysRoute() {
    const { id } = useLocalSearchParams<{ id: string }>();
    const childId = Number(id);
    const { t } = useTranslation();
    const { children, isLoading } = useChildren();

    const child = children.find((item) => item.id === childId);
    useParentStackTitle(t("screens.leaveDays"));

    if (isLoading) {
        return (
            <View className="flex-1 items-center justify-center bg-background">
                <ActivityIndicator />
            </View>
        );
    }

    if (!child) {
        return null;
    }

    return <LeaveDaysScreen key={child.id} child={child} />;
}
